import { render, staticRenderFns } from "./KnFormDebits.vue?vue&type=template&id=167a26c6"
import script from "./KnFormDebits.js?vue&type=script&lang=js&external"
export * from "./KnFormDebits.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports